// extracted by mini-css-extract-plugin
export default {"alert":"DrawerAlert_alert__gJlYs","alertIconWrapper":"DrawerAlert_alertIconWrapper__opOAg","mantine-Alert-icon":"DrawerAlert_mantine-Alert-icon__ED22t"};